<template>
  <div
    :class="`speaker-card ${item.ChairType || ''}`"
    @click="goToProgramme(item.UserId, type)"
  >
    <div class="speaker-card__content">
      <div class="speaker-card__content-text">
        <template v-if="enablePlaceholderSpeakerColor && !image">
            <div 
              class="speaker-card__content-profile-image" 
              :style="{ backgroundColor: config('app_config').config[0].placeholderSpeakerColor }">
            </div>
        </template>
        <template v-else>
            <img
              class="speaker-card__content-profile-image"
              :src="image"
              @error="$event.target.src=require('../../../assets/placeholder.png')"
            />
        </template>
        <div class="flex-details">
          <div>
            <span
              class="speaker-card__content-text-session-name pag-body-text"
              v-text="name"
            />

          </div>
          <div
            class="speaker-card__container-profession-institute"
            v-if="(cardProps.cardConfig.speakerCard.showAuthorInstitute && item.Institute) || (showAuthorTitleProfession && item.Title)"
          >
            <template v-if="(showAuthorTitleProfession && item.Title)">
              <span class="speaker-card__content-text-profession pag-body-text-sm">
                {{ item.Title }}
              </span>
            </template>
            <template v-if="(cardProps.cardConfig.speakerCard.showAuthorInstitute && item.Institute)">
                <span class="speaker-card__content-text-institute pag-body-text-sm">
                  {{ item.Institute }}
                </span>
            </template>
          </div>
          <template v-if="(showCOI || cardProps.cardConfig.speakerCard.showCOI) && item.UserInfo">
            <div class="speaker-card__content-user-info">
              <font-awesome-icon :icon="['fa', 'circle-info']" />
              <span> {{ $t('PAG.COI_text') }}</span>
            </div>
          </template>
          <template v-if="cardProps.cardConfig.speakerCard.showAuthorChairType && item.ChairTypeDisplay && item.ChairType">
            <span class="speaker-card__content-chair-type">
              {{ `(${item.ChairType})` }}
            </span>
          </template>
          <template v-if="(cardProps.cardConfig.speakerCard.showAuthorCity && (city && city.toLowerCase() !== 'all') || cardProps.cardConfig.speakerCard.showAuthorCountry) ">
            <span class="speaker-card__content-text-city-country pag-body-text-sm">
              {{ `${cardProps.cardConfig.speakerCard.showAuthorCity && city || cardProps.cardConfig.speakerCard.showAuthorCountry && country ? openBracket : ''}${cardProps.cardConfig.speakerCard.showAuthorCity && city ? city : ''}${cardProps.cardConfig.speakerCard.showAuthorCity && city && cardProps.cardConfig.speakerCard.showAuthorCountry && country ? ', ': ''}${cardProps.cardConfig.speakerCard.showAuthorCountry && country ? country : ''}${cardProps.cardConfig.speakerCard.showAuthorCity && city || cardProps.cardConfig.speakerCard.showAuthorCountry && country ? closeBracket: ''}` }}
            </span>
          </template>
          <template v-if="userTags && cardProps.cardConfig.speakerCard.showUserTags">
            <br />
            <span
              class="__tags"
              v-for="(tags, idx) in userTags"
              :key="idx"
              v-html="tags"
            />
          </template>

          <div class="speaker-card__button-group">
            <button
              v-if="loggedInUser && acceptcontact && cardProps.cardConfig.speakerCard.showContactSpeaker"
              class="speaker-card__link send-message pag-default-btn-inverse-sm"
              @click.stop="contactSpeaker(item)"
            >
              <font-awesome-icon :icon="['fas', 'envelope']" />
              {{ $t("AppTranslations.SendMessage") }}
            </button>
            <template v-if="loggedInUser">
              <button
                v-if="cardProps.cardConfig.speakerCard.showFavoritesToggle"
                class="speaker-card__link add-to-favourite pag-default-btn-inverse-sm"
                @click.stop="toggleFavorites(item.UserId, type)"
              >
                <template v-if="isFavorite(item.UserId, type)">
                  <font-awesome-icon :icon="['fas', 'star']" />
                  <span v-html="$t('VMX.my_programme_remove_from_favourites')" />
                </template>
                <template v-else>
                  <font-awesome-icon :icon="['far', 'star']" />
                  <span v-html="$t('VMX.my_programme_add_to_favourites')" />
                </template>
              </button>
            </template>
          </div>
        </div>
      </div>
    </div>

    <contact-form-modal
      v-if="loggedInUser && contactFormInitialized && cardProps.cardConfig.speakerCard.showContactSpeaker"
      :speaker="item"
      :show="showContactFormModal"
      @close="handleCloseContactForm"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import myProgrammeMixins from '../../../mixins/myProgrammeMixins'
import dialogMixins from '../../../mixins/dialogMixins'
import accessControl from '~/utilities/accessControl'
import nameMixins from '../../../mixins/nameMixins'

export default {
  name: 'SpeakerFavouritesCard',
  props: {
    item: {
      type: Object,
      default() {
        return null
      },
    },
    cardProps: {
      type: Object,
      default() {
        return {
          cardConfig: {
            speakerCard: {
              showContactSpeaker: true,
              showFavoritesToggle: true,
              showAuthorCity: true,
              showAuthorCountry: true,
              showAuthorChairType: true,
              showAuthorInstitute: true,
              showUserTags: true,
            },
          },
        }
      },
    },
    showCOI: {
      type: Boolean,
      default: false,
    }
  },
  mixins: [
    myProgrammeMixins,
    dialogMixins,
    nameMixins
  ],
  async created() {
    if(!this.solr) {
      await this.loadAuthors()
    }
  },

  computed: {
    ...mapGetters({
      authors: 'pagAuthors/authors',
      config: 'config/configForKey',
      loggedInUser: 'user/user',
      solr: 'instancesState/getSolrPAG'
    }),
    openBracket() {
      const c = this.config('app_config').configV2
      return c?.defaultV2?.openBracket
        ? c.defaultV2.openBracket
        : '('
    },
    closeBracket() {
      const c = this.config('app_config').configV2
      return c?.defaultV2?.closeBracket
        ? c.defaultV2.closeBracket
        : ')'
    },
    image() {
    if (this.item) {
      if (this.item.ProfileUrl) return this.item.ProfileUrl;
      const user = this.authors.filter((author) => author.UserId === this.item.UserId);
      if (user[0]?.ProfileUrl) {
        return user[0].ProfileUrl;
      } else if (this.enablePlaceholderSpeakerColor) {
        return ''; 
      } else {
        return this.config('app_config').config[0].placeholderSpeaker;
      }
    }
    if (this.enablePlaceholderSpeakerColor) {
      return ''; 
    }
    return this.config('app_config').config[0].placeholderSpeaker;
  },
    userTags() {
      const atF = this.config('app_config').configV2.defaultV2.excludeUserTags || []
      return this.item && this.item.UserTags ? this.item.UserTags.split('|').filter(item => !atF.includes(item)) : null
    },
    showAuthorTitle() {
      const c = this.config('app_config').configV2
      return c?.defaultV2?.showAuthorTitle
        ? c.defaultV2.showAuthorTitle
        : false
    },
    showAuthorTitleProfession() {
      const c = this.config('app_config').configV2
      return c?.defaultV2?.showAuthorTitleProfession
        ? c.defaultV2.showAuthorTitleProfession
        : false
    },
    enablePlaceholderSpeakerColor() {
      const c = this.config('app_config').configV2
      return c?.defaultV2?.enablePlaceholderSpeakerColor
        ? c.defaultV2.enablePlaceholderSpeakerColor
        : false
    },
    enableDisplayNameWithInitials() {
      const c = this.config('app_config').configV2
      return c?.defaultV2?.enableDisplayNameWithInitials
        ? c.defaultV2.enableDisplayNameWithInitials
        : false
    },
    titleCondition() {
      return this.showAuthorTitleProfession ? false : this.showAuthorTitle
    },
    name() {
    if (this.item) {
        if (this.item.Name) {
            return this.capitalizeEveryWord(this.item.Name);
        }

        const user = this.authors.filter((author) => author.UserId === this.item.UserId);

        if (user.length) {
            if (this.enableDisplayNameWithInitials) {
                return user[0]?.Title
                    ? `${this.capitalizeEveryWord(user[0]?.Firstname)} ${this.capitalizeEveryWord(user[0]?.Surname)}, ${user[0]?.Title}`
                    : `${this.capitalizeEveryWord(user[0]?.Firstname)} ${this.capitalizeEveryWord(user[0]?.Surname)}`;
            } else {
                return this.titleCondition
                    ? `${user[0]?.Title} ${this.capitalizeEveryWord(user[0]?.Firstname)} ${this.capitalizeEveryWord(user[0]?.Surname)}`
                    : `${this.capitalizeEveryWord(user[0]?.Firstname)} ${this.capitalizeEveryWord(user[0]?.Surname)}`;
            }
        } else {
            if (this.enableDisplayNameWithInitials) {
                return this.item.Title
                    ? `${this.capitalizeEveryWord(this.item.Firstname)} ${this.capitalizeEveryWord(this.item.Surname)}, ${this.item.Title}`
                    : `${this.capitalizeEveryWord(this.item.Firstname)} ${this.capitalizeEveryWord(this.item.Surname)}`;
            } else {
                return this.titleCondition
                    ? `${this.item.Title} ${this.capitalizeEveryWord(this.item.Firstname)} ${this.capitalizeEveryWord(this.item.Surname)}`
                    : `${this.capitalizeEveryWord(this.item.Firstname)} ${this.capitalizeEveryWord(this.item.Surname)}`;
            }
        }
    }

    return null;
},
    city() {
      if (this.item) {
        if (this.item.City) return this.item.City
        const user = this.authors.filter((author) => author.UserId === this.item.UserId)

        return user[0]?.City
      }

      return null
    },
    country() {
      if (this.item) {
        if (this.item.Country) return this.item.Country
        const user = this.authors.filter((author) => author.UserId === this.item.UserId)

        return user[0]?.Country
      }

      return null 
    },
    acceptcontact() {
      if (this.item) {
        if (this.item.AcceptContact) return this.item.AcceptContact
        const user = this.authors.filter((author) => author.UserId === this.item.UserId)

        return user[0]?.AcceptContact
      }

      return null
    },
    user() {
      if (this.item) {
        const user = this.authors.filter((author) => author.UserId === this.item.UserId)

        return user[0]
      }

      return null
    },
    type() {
      if (this.item && this.item.Type) {
        return this.item.Type
      }
      return 'Author'
    },
  },
  methods: {
    ...mapActions({
      loadAuthors: 'pagAuthors/search',
    }),
  },
}
</script>
<style lang="scss" scoped>
.speaker-card {
  height: 100%;
  background-color: var(--pag-box-background);
  padding: calc(var(--pag-box-padding) * 2);
  border: var(--pag-box-border);
  border-radius: var(--pag-box-border-radius);
  .speaker-card__content-text {
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 100%;
    gap: var(--pag-box-gap);
    @media (max-width: 600px) {

      img {
        width: 50px;
        height: 50px;
        min-width: 50px;
        min-height: 50px;
      } 

    }
    .flex-details {
      width: 100%;
      padding-left: unset;
    }
  }

  .speaker-card__container-profession-institute {
    display: flex;
    flex-direction: column;
    gap:.25rem;

  }
  .speaker-card__button-group > button {
    display:flex;
    align-items:center;
    gap:.25rem;
  }

  .__tags {
    border: solid 1px var(--pag-primary);
    color: var(--pag-primary);
    display: inline-block;
    border-radius: 0.25rem;
    font-size: 0.875rem;
    line-height: 1.5;
    padding: 0.2rem 0.7rem;
    text-align: center;
    vertical-align: middle;
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .__tags:not(:nth-child(1)) {
    margin-right: 5px;
    margin-top: 5px;
  }
}
</style>
